import _groupBy from 'lodash.groupby';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import storageKeys from 'data/storageKeys';
import { getClosestLocationsBySortingAlgo } from 'utils/booking/getClosestLocationsBySortingAlgo';
import { flagshipStoreExists } from 'utils/orderByFlagStore';

function putFlagshipStoresFirst(stepLocationCF, allLocations, sortingAlgorithm) {
  return (
    stepLocationCF?.useFlagshipStoreLabel &&
    stepLocationCF?.useFlagshipStorePriority &&
    flagshipStoreExists(allLocations.nodes, sortingAlgorithm)
  );
}

function getUserLocation() {
  const userLocation = JSON.parse(localStorage.getItem(storageKeys.userCoordinates)) || {};
  const userLocationExists = !!(userLocation.latitude && userLocation.longitude);
  return [userLocationExists, userLocation];
}

function orderLocations(steps, allLocations, sortingAlgorithm) {
  const orderedAllLocations = { nodes: allLocations.nodes };
  const stepLocationCF = steps.find(step => step.__typename === stepTypes.location);
  const [userLocationExists, userLocation] = getUserLocation();

  if (userLocationExists) {
    const closestLocations = getClosestLocationsBySortingAlgo(allLocations.nodes, userLocation, sortingAlgorithm);

    const nonClosestLocations = allLocations.nodes.filter(
      location => !closestLocations.some(closestLocation => closestLocation.id === location.id),
    );

    const locationsByDistance = closestLocations.concat(
      nonClosestLocations?.sort((a, b) => a.distanceInKm - b.distanceInKm),
    );

    if (putFlagshipStoresFirst(stepLocationCF, allLocations, sortingAlgorithm)) {
      const closestFlagshipStore = locationsByDistance.find(location => !!location.flagshipStoreLabel);
      orderedAllLocations.nodes = [
        closestFlagshipStore,
        ...locationsByDistance.filter(location => location.id !== closestFlagshipStore.id),
      ];
    } else {
      orderedAllLocations.nodes = locationsByDistance;
    }
  } else {
    if (putFlagshipStoresFirst(stepLocationCF, allLocations, sortingAlgorithm)) {
      const locationsByFlagshipStore = _groupBy(allLocations.nodes, location =>
        location.flagshipStoreLabel ? 'flagshipStores' : 'nonFlagshipStores',
      );

      orderedAllLocations.nodes = [
        ...(Array.isArray(locationsByFlagshipStore.flagshipStores) ? locationsByFlagshipStore.flagshipStores : []),
        ...(Array.isArray(locationsByFlagshipStore.nonFlagshipStores)
          ? locationsByFlagshipStore.nonFlagshipStores
          : []),
      ];
    }
  }

  return orderedAllLocations;
}

export default orderLocations;
